import { ContainerStep, ContainerStepItem } from "./style";
import { Box, Typography } from "@mui/material";
import InputNumber from "../../../UI/Input/InputNumber";
import { fnLocalizeFilter } from "../../../../services/localize.service";
import { useGlobalContext } from "../../../../services/context.service";
import * as React from "react";
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { useMemo, useState } from "react";

interface ISourceSum {
	maxSum: number | undefined;
	value: number;

	onChange ( sum: number ): void;
}

export default function SourceSum ( { value, maxSum = 0, onChange }: ISourceSum ) {

	/* Получаем языковую локаль */
	const { locale } = useGlobalContext();

	const [ initModule, setInit ] = useState( false );

	const handleChange = ( e: React.ChangeEvent<HTMLInputElement> ) => {
		setInit( true );
		onChange( +e.target.value );
	};

	const showWarning = useMemo( () => {
		return ( initModule && value <= 0 ) || value > maxSum;
	}, [ value ] )

	return (
		<ContainerStep>
			<ContainerStepItem property={ JSON.stringify( { justifyContent: "space-between" } ) }>
				<Typography
					sx={ { paddingLeft: ".5rem" } }>{ fnLocalizeFilter( locale, '_lang.module.common.title.titleSum' ) }</Typography>
				<Box sx={ { display: "flex", justifyContent: "flex-end", alignItems: "center" } }>

					{ showWarning && <DoNotDisturbAltIcon sx={ { fontSize: "2rem", color: "#FF0000" } }/> }

					<InputNumber sx={ { width: "100%", textAlign: "right" } }
					             placeholder={ '' }
					             type={ 'number' }
					             value={ value }
					             onChange={ handleChange }

					/>

				</Box>
			</ContainerStepItem>
		</ContainerStep>
	)
}
